// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__yroUp","web_layout":"styles_web_layout__vuArD"};